var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageDiv"},[_c('v-card',{staticClass:"main-card"},[_c('div',{staticStyle:{"width":"100%","height":"300px"}},[_c('v-card-title',[_vm._v(" TBD ... ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }